export const openEditing = ({ setEditing }) => () => setEditing(true);
export const closeEditing = ({ setEditing }) => () => setEditing(false);

export const openDeleting = ({ setDeleting }) => () => setDeleting(true);
export const closeDeleting = ({ setDeleting }) => () => setDeleting(false);
